module.exports = __webpack_public_path__ + "static/media/rocket.11e1d91f.png";